// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609041145/js/" + chunkId + "." + {"44":"c74d2ef7","225":"cc5e9fdb","481":"7af069e5","486":"91efc60a","770":"0ce28342"}[chunkId] + ".0.2616853016820415.chunk.js";
};